declare const RUNNING_ENV: "local" | "preview" | "development" | "staging" | "production" | "test";
declare const STORYTELL_API_URL: string;

export const getBackendURL = (): string => {
  // RUNNING_ENV is a build-time define provided by consumers that actually issue
  // requests (the bluesky web app). Surfaces that bundle the client transitively
  // but never call it — the Chief webview routes all I/O through its Go process —
  // don't define it. Constructing a request config (a module-level singleton)
  // must not throw there, so treat an absent define as the production default.
  const env = typeof RUNNING_ENV === "undefined" ? undefined : RUNNING_ENV;
  if (env === "local") {
    // Browser-only: server-side code runs next to the backend and keeps
    // localhost even when remote browser access goes through another host.
    const override = typeof window !== "undefined" && typeof STORYTELL_API_URL !== "undefined" ? STORYTELL_API_URL : "";
    return override || "http://localhost:3443";
  }
  if (env === "development") {
    return "https://api.storytell-development.ai";
  }
  return "https://api.storytell.ai";
};
